import Vue from 'vue'
Vue.directive('stable-html', {
    bind(el, binding) {
      el.innerHTML = binding.value;
      // 存储初始节点的深拷贝和outerHTML
      el._stableHtmlPool = Array.from(el.childNodes).map(node => ({
        html: node.outerHTML,
        node: node.cloneNode(true)
      }));
    },

    update(el, binding) {
      if (binding.value === binding.oldValue) return;
      console.log(binding.value);
      
      const newHTML = binding.value;
      const parser = new DOMParser();
      const doc = parser.parseFromString(newHTML, 'text/html');
      const newNodes = Array.from(doc.body.childNodes);

      // 创建新旧节点对比映射
      const maintainNodes = [];
      console.log([...el.childNodes], Array.from(doc.body.childNodes));
      
      // 创建旧节点数组的副本
      const oldChildren = Array.from(el.childNodes);
      
      // 第一遍扫描：匹配所有新旧节点
      newNodes.forEach(newNode => {
        const newHtml = newNode.outerHTML || newNode.textContent;
        const index = oldChildren.findIndex(oldNode => {
          const oldHtml = oldNode.outerHTML || oldNode.textContent;
          return oldHtml === newHtml;
        });
        
        if (index !== -1) {
          // 找到匹配的旧节点
          const oldNode = oldChildren[index];
          maintainNodes.push({
            oldNode,
            newNode
          });
          // 从旧节点数组中移除已匹配的节点
          oldChildren.splice(index, 1);
        } else {
          // 没有匹配的旧节点，需要添加新节点
          const clonedNode = newNode.cloneNode(true);
          el.appendChild(clonedNode);
          maintainNodes.push({
            oldNode: null,
            newNode: clonedNode
          });
        }
      });
      
      // 移除未匹配的旧节点
      oldChildren.forEach(oldNode => {
        el.removeChild(oldNode);
      });

      // 更新节点池（保留原始节点引用）
      el._stableHtmlPool = maintainNodes.map(pair => ({
        html: pair.newNode.outerHTML || pair.newNode.textContent,
        node: pair.newNode.cloneNode ? pair.newNode.cloneNode(true) : pair.newNode
      }));
    }
  });

// import Vue from 'vue'

// // 增强型特征签名生成
// const getNodeSignature = node => {
//   if (!node) return ''
//   if (node.nodeType === Node.ELEMENT_NODE) {
//     // 优先使用稳定标识
//     const stableSign = node.dataset?.sign || node.id || ''
//     if (stableSign) return `${node.nodeName}|${stableSign}`
    
//     // 特殊处理 iframe
//     if (node.tagName === 'IFRAME') {
//       return `IFRAME|${node.src}`
//     }
    
//     // 常规元素使用类名组合
//     return `${node.nodeName}|${node.className}`
//   }
//   return node.textContent.trim()
// }

// // 属性同步器（保留已有引用）
// const syncAttributes = (oldNode, newNode) => {
//   // 移除不存在的新属性
//   Array.from(oldNode.attributes).forEach(attr => {
//     if (!newNode.hasAttribute(attr.name)) {
//       oldNode.removeAttribute(attr.name)
//     }
//   })
//   // 同步所有新属性
//   Array.from(newNode.attributes).forEach(attr => {
//     if (oldNode.getAttribute(attr.name) !== attr.value) {
//       oldNode.setAttribute(attr.name, attr.value)
//     }
//   })
// }

// // 智能子节点同步
// const syncChildren = (oldParent, newParent) => {
//   const oldChildren = Array.from(oldParent.childNodes)
//   const newChildren = Array.from(newParent.childNodes)
//   const keyedOld = new Map()
  
//   // 建立旧节点索引（使用最后出现的签名）
//   oldChildren.forEach(node => {
//     const key = getNodeSignature(node)
//     keyedOld.set(key, node)
//   })

//   // 按新顺序重建节点
//   newChildren.forEach(newChild => {
//     const key = getNodeSignature(newChild)
//     const oldChild = keyedOld.get(key)

//     if (oldChild) {
//       // 移动已有节点到正确位置
//       if (oldChild !== oldChildren[0]) {
//         oldParent.insertBefore(oldChild, oldChildren[0] || null)
//       }
//       // 递归同步子结构
//       if (oldChild.nodeType === Node.ELEMENT_NODE) {
//         syncAttributes(oldChild, newChild)
//         // 特殊处理 iframe
//         if (oldChild.tagName !== 'IFRAME') {
//           syncChildren(oldChild, newChild)
//         }
//       }
//       oldChildren.shift()
//     } else {
//       // 插入新节点
//       oldParent.insertBefore(newChild.cloneNode(true), oldChildren[0] || null)
//     }
//   })

//   // 移除多余旧节点
//   oldChildren.forEach(node => node.remove())
// }

// Vue.directive('stable-html', {
//   bind(el, binding) {
//     el.innerHTML = binding.value
//     // 初始化节点索引
//     el._nodeMap = Array.from(el.childNodes).map(node => ({
//       signature: getNodeSignature(node),
//       node
//     }))
//   },

//   update(el, binding) {
//     if (binding.value === binding.oldValue) return

//     // 解析新结构
//     const doc = new DOMParser().parseFromString(binding.value, 'text/html')
//     const newRoot = doc.body
//     const newChildren = Array.from(newRoot.childNodes)
    
//     // 同步根节点结构
//     syncChildren(el, newRoot)

//     // 更新节点索引
//     el._nodeMap = Array.from(el.childNodes).map(node => ({
//       signature: getNodeSignature(node),
//       node
//     }))
//   }
// })

// import Vue from 'vue'

// // 内容指纹生成方法（独立函数）
// const contentFingerprint = (text) => {
//   let hash = 0
//   const str = text.replace(/\s+/g, ' ').trim()
//   if (str.length === 0) return '0'
  
//   for (let i = 0; i < str.length; i++) {
//     const char = str.charCodeAt(i)
//     hash = (hash << 5) - hash + char
//     hash |= 0 // 转换为32位整数
//   }
//   return hash.toString(36)
// }

// // 节点签名生成器（独立函数）
// const getNodeSignature = (node, index) => {
//   if (!node) return ''
  
//   const parts = []
  
//   // 元素节点处理
//   if (node.nodeType === Node.ELEMENT_NODE) {
//     parts.push(node.nodeName)
    
//     // 收集稳定属性
//     const stableAttrs = ['data-sign', 'data-type', 'id', 'class']
//     stableAttrs.forEach(attr => {
//       const val = node.getAttribute(attr)
//       if (val) parts.push(`${attr}=${val.replace(/\s+/g, '')}`)
//     })

//     // 代码块特殊处理
//     if (node.classList.contains('cherry-code-expand')) {
//       const codeText = Array.from(node.querySelectorAll('.code-line'))
//         .map(line => line.textContent.trim())
//         .join('|')
//       parts.push(`codeHash=${contentFingerprint(codeText)}`)
//     }
    
//     // 列表项位置标记
//     if (node.classList.contains('cherry-list-item')) {
//       parts.push(`pos=${index}`)
//     }
//   } 
//   // 文本节点处理
//   else {
//     parts.push(`txt=${contentFingerprint(node.textContent)}`)
//   }

//   return parts.join('::')
// }

// // 创建节点映射表
// const createNodeMap = (el) => {
//   el._stableNodes = Array.from(el.childNodes).map((node, i) => ({
//     sign: getNodeSignature(node, i),
//     node
//   }))
// }

// // 核心DOM同步逻辑
// const syncNodeStructure = (oldParent, newParent) => {
//   const oldNodes = Array.from(oldParent.childNodes)
//   const newNodes = Array.from(newParent.childNodes)
  
//   // 建立旧节点索引
//   const oldNodeMap = new Map()
//   oldNodes.forEach((node, i) => {
//     oldNodeMap.set(getNodeSignature(node, i), node)
//   })

//   // 创建新节点指纹列表
//   const newSignList = newNodes.map((node, i) => getNodeSignature(node, i))
  
//   // 第一阶段：清理废弃节点
//   oldNodes.forEach((node, i) => {
//     const sign = getNodeSignature(node, i)
//     if (!newSignList.includes(sign)) {
//       node.remove()
//     }
//   })

//   // 第二阶段：调整节点顺序
//   const fragment = document.createDocumentFragment()
//   newSignList.forEach(sign => {
//     const existing = oldNodeMap.get(sign)
//     if (existing && existing.parentNode === oldParent) {
//       fragment.appendChild(existing)
//     }
//   })
//   oldParent.appendChild(fragment)

//   // 第三阶段：补充新增节点
//   newNodes.forEach((newNode, i) => {
//     const sign = getNodeSignature(newNode, i)
//     if (!oldNodeMap.has(sign)) {
//       oldParent.appendChild(newNode.cloneNode(true))
//     }
//   })
// }

// // Vue指令定义
// Vue.directive('stable-html', {
//   bind(el, binding) {
//     el.innerHTML = binding.value
//     createNodeMap(el)
//   },

//   update(el, binding) {
//     if (binding.value === binding.oldValue) return
    
//     const doc = new DOMParser().parseFromString(binding.value, 'text/html')
//     syncNodeStructure(el, doc.body)
//     createNodeMap(el)
//   }
// })